import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
} from "@ionic/angular";
import { ROUTE } from "../../../constant/routes";
import { STORAGE } from "../../../constant/storages";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { TEXT } from "../../../text_control";
import { errMsg } from "../../../text_control/error-msg";
import { SUSSESS } from "../../../text_control/success-msg";
import { BTN } from "../../../text_control/text_button";
import { TEXT_TABLE } from "../../../text_control/text_table";
import { _getStorage, _setStorage } from "../../../utils/local-storage";

@Component({
  selector: "app-tax-invoice-save",
  templateUrl: "./tax-invoice-save.component.html",
  styleUrls: ["./tax-invoice-save.component.scss"],
})
export class TaxInvoiceSaveComponent implements OnInit {
  @Input() data: string;
  email = "";

  datamodal = [];
  buyer_id: any;
  dataparam: any;
  tpno: any;
  remark: String = "";
  orderNo: String = "";
  receiptDate: String = "";
  label_text: any = {};
  isShowBranchNo: any;

  text: any;
  textBTN: any;
  textTB: any;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  headerNewService: any;

  constructor(
    public alertController: AlertController,
    public modalCtrl: ModalController,
    public router: Router,
    public apiservice: ApiserviceService,
    public navParams: NavParams,
    public loadingController: LoadingController,
    private appService: AppService
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);

    this.text = TEXT;
    this.textBTN = BTN;
    this.textTB = TEXT_TABLE;
    this.datamodal = navParams.get("data");
    this.tpno = navParams.get("tpno");
    this.buyer_id = navParams.get("buyer_id");
    this.email = navParams.get("email");
    this.remark = navParams.get("remark");
    this.orderNo = navParams.get("orderNo");
    this.isShowBranchNo = navParams.get("isShowBranchNo");
    this.headerNewService = navParams.get("newService");
    this.receiptDate = navParams.get("receipt_date");
  }

  ngOnInit() {}
  async validateEmail() {
    const alert = await this.alertController.create({
      cssClass: "resend-confirm-email",
      header: errMsg.errorEmail,
      buttons: [
        {
          text: "OK",
          role: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  onDisableClick: boolean = false;
  async confirmWaitAlert() {
    if (this.email) {
      const re =
        /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email)) return this.validateEmail();
    }

    this.onDisableClick = true;
    setTimeout(async () => {
      await this.confirmAlert();
    }, 2000);
  }

  async confirmAlert() {
    console.log("data ABB =====: ", this.datamodal);
    let groupData = [];
    for (const item of this.datamodal) {
      const req = {
        fulltax: {
          confirmcreate: "confirm",
          searchABB: {
            bu: this.userBu,
            userid: this.userID,
            userSource: this.userSource,
            loc: this.userLoc,
            receiptno: [item],
            receipt_date: this.receiptDate,
            tpno: this.tpno,
            type: "",
          },
          userBu: this.userBu,
          userLoc: this.userLoc,
          userRole: this.userRole,
          userSource: this.userSource,
          user_id: this.userID,
          buyer_id: this.buyer_id,
          doctype: "1",
          email: this.email,
          remark: this.remark,
          orderNo: this.orderNo,
          isShowBranchNo: this.isShowBranchNo,
        },
      };
      console.log("req confirm =======: ", req);
      let header: any;
      if (this.headerNewService) {
        header = this.headerNewService;
      }

      await this.apiservice
        ._post(
          this.apiservice.apiUrl + this.apiservice.confirmCreate,
          req,
          header
        )
        .then((res) => {
          console.log("res confirm ======:", res);

          try {
            if (res.statusCode === 200) {
              groupData.push({
                status: true,
                message: "สำเร็จ",
                request: req,
                ...res.data[0].data,
              });
            } else {
              groupData.push({
                status: false,
                message: "ไม่สำเร็จ",
                request: req,
                receiptNo: item,
              });
            }
          } catch (error) {
            groupData.push({
              status: false,
              message: "ไม่สำเร็จ",
              request: req,
              receiptNo: item,
            });
          }
        });
      console.log("groupdata ======: ", groupData);
    }
    const alert = await this.alertController.create({
      cssClass: "my-confirm-alert",
      header: SUSSESS.send_email_etax,
    });

    await alert.present();
    setTimeout(async () => {
      alert.dismiss(true);
      this.modalCtrl.dismiss({ dismissed: true });
      _setStorage(STORAGE.DATA_PREVIEW_TAXINVOICE, groupData);
      this.router.navigate([ROUTE.TAXINVOICE_PREVIEW], {
        queryParams: {
          newService: await this.apiservice.setBase64(
            JSON.stringify(this.headerNewService)
          ),
        },
      });
    }, 5000);
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }

  dismiss() {
    this.modalCtrl.dismiss({ dismissed: true });
    this.appService.setActive(3);
  }
}
